
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import AccessesListView from "./accesses-list.html";

angular.module("accesses", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('accesses', {
                url: "/accesses",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('accesses.list', {
                url: "/list",
                controller: "AccessesListCtrl",
                template: AccessesListView,
                data: { pageTitle: 'Accesos' }
            })
        ;
    }])
;